<template>
    <div>
        <ModuleHeader :moduleName="text.logout"/>
        <div class="content-container">
            <p class="explication-text">{{ text.hello }} {{ name }}</p>
            <br>
            <br>
            <div class="buttons">
                <div class="up-btn">
                    <BMButton @is-clicked="logout">{{ text.toLogout }}</BMButton>
                </div>
                <BMButton route="/">{{ text.toHomePage }}</BMButton>
            </div>
            <!-- <LangSelector/> -->
        </div>
    </div>
</template>

<script>
import ModuleHeader from '@/components/ModuleHeader'
import BMButton from '@/components/BlackMoonUI/BMButton'
import LangSelector from '@/components/LangSelector'

export default {
    components: {
        ModuleHeader,
        BMButton,
        LangSelector
    },
    computed: {
        text(){
            return this.$texts[this.$i18n.locale].logout
        },
        name(){
            return this.$sharedStore.get('firstname').toLowerCase().replace(/\b(\w)/g, x => { return x.toUpperCase() }) + ' ' + this.$sharedStore.get('lastname').toUpperCase()
        }
    },
    methods: {
        logout(){
            this.$sharedStore.set('user_id', null)
            localStorage.removeItem('auth-token')
            this.$axios.defaults.headers.common['Authorization'] = null
            this.$router.push('/not-logged-in')
        }
    }
}
</script>

<style lang="scss" scoped>
    .explication-text {
        text-align: center;
        padding: 4vw;
        font-size: 12px;
    }

    .buttons {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
    }

    .up-btn {
        margin-bottom: 40px;
    }
</style>